import React from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { useParams } from 'react-router'
import { shallowEqual, useSelector } from 'react-redux'
import RpqsEventsApp from '../events/RpqsEventsApp'

const RpqsEventApp = () => {
    const {
        rpqs,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
    }), shallowEqual)

    const { annee, idCollectivite } = useParams()

    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: rpqs.year || `${i18n.year} ${i18n.unknown}`,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: rpqs.name || i18n.unknown,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: i18n.event,
        href: `rpqs/${annee}/collectivite/${idCollectivite}/event`,
    }], [rpqs, annee, idCollectivite])

    return <RpqsEventsApp />
}

export default RpqsEventApp
